import { render } from "./FlyInputLabel.vue?vue&type=template&id=5cd1fe8c"
import script from "./FlyInputLabel.vue?vue&type=script&lang=js"
export * from "./FlyInputLabel.vue?vue&type=script&lang=js"

import "./FlyInputLabel.vue?vue&type=style&index=0&id=5cd1fe8c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__